import React from 'react';
import Alpha, { AlphaProps } from '../color-alpha';
import { HsvaColor } from '../utils/color-convert';

export interface HueProps extends Omit<AlphaProps, 'onChange'> {
    onChange?: (newHue: HsvaColor) => void;
}

const Hue = React.forwardRef<HTMLDivElement, HueProps>((props, ref) => {
    const {
        prefixCls = 'c-color-hue',
        className,
        onChange,
        direction = 'horizontal',
        hsva,
        height = 8,
        ...other
    } = props;
    return (
        <Alpha
            ref={ref}
            className={`${prefixCls} ${className || ''}`}
            {...other}
            direction={direction}
            height={height}
            background={`linear-gradient(to ${
                direction === 'horizontal' ? 'right' : 'bottom'
            }, #FF0000 0%, #FFD500 26.04%, #00FFAA 45.83%, #00FFF0 54.69%, #330BFF 72.92%, #FF00E5 85.42%, #FF0000 100%`}
            hsva={{ h: hsva.h, s: 100, v: 100, a: hsva.h / 360 }}
            onChange={(_, interaction) => {
                onChange &&
                    onChange({
                        ...hsva,
                        h: direction === 'horizontal' ? 360 * interaction.left : 360 * interaction.top,
                    });
            }}
        />
    );
});

Hue.displayName = 'Hue';

export default Hue;
